import React from "react";

import AuthCardLayout from "layouts/AuthCardLayout";

import PasswordResetForm from "components/authentication/PasswordResetForm";

const PasswordReset = () => {
  return (
    <AuthCardLayout>
      <h3>Reset password</h3>
      <PasswordResetForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default PasswordReset;
